<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.choose_package_search') || '包装编号/名称搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    destinationPortName: { type: String, default: '' },
  },
  data() {
    return {
      form: { keyword: this.destinationPortName },
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.form)
    },
  },
}
</script>
